<span *ngIf="isLoading | async"><i wrapper> </i></span>
